import { ArrowDropDown } from '@mui/icons-material';
import {
    AccordionSummary,
    Box,
    SxProps,
    Theme,
    Typography,
    alpha,
} from '@mui/material';
import { ReactNode } from 'react';

export const AccordionHeader = ({
    title,
    suffix,
    expandIcon,
    sx,
}: {
    title: string;
    suffix?: ReactNode;
    expandIcon?: ReactNode;
    sx?: SxProps<Theme>;
}) => {
    return (
        <AccordionSummary
            sx={{
                m: '8px 0',
                ...sx,
            }}
            expandIcon={
                expandIcon ?? (
                    <ArrowDropDown
                        sx={(theme) => ({
                            color: alpha(theme.palette.common?.black, 0.3),
                        })}
                    />
                )
            }
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '8px',
                }}
            >
                <Typography typography="openSans.subtitle1Medium">
                    {title}
                </Typography>
                {suffix}
            </Box>
        </AccordionSummary>
    );
};
